import { writable } from 'svelte/store'
import { database } from './indexeddb.js'

const STORE_NAME = 'friend_groups'

export function createFriendGroupsStore () {
  const { subscribe, set } = writable([])

  async function load () {
    const items = await database.getAll(STORE_NAME)
    set(items)
    return items
  }

  return {
    subscribe,
    load,

    async set (group) {
      await database.put(STORE_NAME, group)
      await load()
    },

    async delete (id) {
      await database.delete(STORE_NAME, id)
      await load()
    },

    async clearAll () {
      await database.clear(STORE_NAME)
      await load()
    }
  }
}
